import { adminOrderMemoModal } from "@/atoms/order/admin-order-memo-modal";
import { Body14Medium } from "@/components/typography/Body14Medium";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { CartItemDto } from "@/types/dto/cart-item-dto";
import { useSetRecoilState } from "recoil";

interface Props {
  item: CartItemDto;
  canEdit?: boolean;
  memoEditButton?: React.ReactNode;
}

export const ItemDetailCell: React.FC<Props> = ({
  item,
  canEdit = true,
  memoEditButton,
}) => {
  const setModal = useSetRecoilState(adminOrderMemoModal);

  return (
    <div className="box-border flex items-start m-4 min-h-fit">
      <div className="flex flex-col w-full">
        <div className="flex justify-between w-full">
          <div className="flex">
            {item.imageUrls.length > 0 && (
              <img
                src={item.imageUrls[0]}
                alt={item.name}
                className="w-[32px] mr-[8px]"
              />
            )}
            <Body14Regular>{item.name}</Body14Regular>
          </div>
          {canEdit && memoEditButton}
        </div>
        {item.memoItems && item.memoItems.length > 0 && (
          <div className="flex gap-2 mt-4">
            <img
              src="/svg/arrow-mid-outline.svg"
              alt="arrow"
              className="w-6 h-6"
            />
            <div className="flex flex-col gap-2">
              {item.memoItems.map((item) => (
                <div key={item.name} className="flex flex-col">
                  <Body14Medium className="text-semantic-text-body">
                    {item.name}
                  </Body14Medium>
                  <Footnote12Description className="text-semantic-text-secondary">
                    {item.value}
                  </Footnote12Description>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemDetailCell;
